<template>
	<div>
		<img src="/assets/images/desktop/home.png"
		     class="w-100 d-none d-xl-block d-lg-block d-md-none d-sm-none"
		     draggable="false"
		     alt="">
		<img src="/assets/images/movil/home.png"
		     class="w-100 d-block d-xl-none d-lg-none d-md-block d-sm-block"
		     draggable="false"
		     alt="">
		<div class="border-5 border-bottom border-dark-pink"></div>
		<div class="container">
			<div class="row">
				<div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 py-5">
					<div class="row">
						<div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
							<div class="h1 text-cyan">
								¿Qué es la semana de inducción?
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-12">
							<p class="text-blue">
								En este sitio podrás encontrar la información necesaria para comenzar la aventura de
								vivir la experiencia universitaria en una de las Instituciones de Educación Superior más
								australes del mundo, la Universidad de Aysén. En este espacio encontrarás módulos y
								actividades destinadas a brindarte una primera aproximación a nuestra Universidad. A
								través de ellas, adquirirás importantes herramientas que te permitirán insertarte de
								mejor manera a la vida universitaria.
							</p>
						</div>
					</div>
				</div>
				<div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 py-5 bg-cyan">
					<div class="h1 text-white text-center mb-5">
						Programa
					</div>
					<p class="text-white text-center px-5">
						Aquí encontrarás todo el Programa de Actividades que tenemos preparadas para ti entre los días 1
						y 3 de Marzo. ¡No te las puedes perder!
					</p>
					<div class="text-center py-4">
						<link-to :to="{name: 'programa'}"
						         a-class="btn btn-light rounded-pill shadow">
							Ver Programa
						</link-to>
					</div>
				</div>
			</div>
		</div>
		<div class="bg-light-yellow py-5">
			<div class="container">
				<div class="row">
					<div class="col-12n h1 text-dark-pink">
						Modulos de actividades programadas
					</div>
					<div class="col-12">
						<p class="text-blue">
							La Universidad es un mundo nuevo, lleno de oportunidades y queremos que los descubras desde
							el primer día, los siguientes módulos te ofrecerán información importante sobre algunas
							Unidades y Servicios que ofrece la Universidad de Aysén para ti.
						</p>
					</div>
				</div>
				<div class="row justify-content-center">
					<div v-for="modulo in modulos"
					     class="col-xl-4 col-lg-4 col-md-6 col-sm-6 mb-4">
						<link-to :to="{name: 'actividades-modulo', params: {modulo: modulo.route}}" a-class="">
							<div class="zoom-in modulo w-100 h-100 rounded-3 p-3">
								<div class="container-fluid h-100">
									<div class="row h-100">
										<div class="col-8 h-100 d-flex align-items-center">
											<span class="text-white h5" v-html="modulo.title"></span>
										</div>
										<div class="col-4 h-100 d-flex align-items-center justify-content-center">
											<img :src="'/assets/images/iconos-modulos/' + modulo.image"
											     class="w-100"
											     draggable="false"
											     :alt="modulo.title"/>
										</div>
									</div>
								</div>
							</div>
						</link-to>
					</div>
				</div>
			</div>
		</div>
		<div class="container py-5">
			<div class="row">
				<div class="col-12 h1 text-dark-pink">
					Bienvenida
				</div>
			</div>
			<div class="row">
				<div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 pb-3">
					<p class="text-blue">
						La Rectora de la Universidad de Aysén, Srta. Natacha Pino Acuña, tiene el agrado de invitarle a
						la ceremonia oficial de bienvenida 2023, la que se realizará en modalidad presencial en el Salón
						MOP el 1 de marzo.
					</p>
					<div class="bg-cyan shadow rounded-3">
						<div class="col-12">
							<div class="row pt-3">
								<div v-for="red in redes"
								     class="col-6 py-3 d-flex justify-content-end align-items-center">
									<a :href="red.link"
									   target="_blank">
										<img :src="'/assets/images/redes-sociales/' + red.image"
										     class="img-fluid"
										     draggable="false"
										     :alt="red.name"/>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-for="video in videos" class="col-xl-6 col-lg-6 col-md-12 col-sm-12 pb-3">
					<div class="bg-dark-pink text-white p-2"
					     v-html="video.title"></div>
					<div class="ratio ratio-16x9">
						<iframe :src="'https://www.youtube.com/embed/'+video.id+'?rel=0'"
						        :title="video.title" allowfullscreen></iframe>
					</div>
				</div>
			</div>
		</div>
		<banda-ver-saludos/>
	</div>
</template>

<script>
import BandaVerSaludos from "../layout/BandaVerSaludos";
import {Mock} from "../common/mock";

export default {
	name: 'inicio',
	components: {
		BandaVerSaludos
	},
	data: () => ({
		modulos: Mock.modulos,
		videos: [
			{title: 'Bienvenida de nuestra Rectora Dra. Natacha Pino Acuña', id: 'Zyv9QSlnqSw'},
			//{title: 'Actividades Extraprogramaticas Uaysén', id: '376j9iqhK30'},
			{title: 'Matrículas Admisión 2023', id: '246Pp3hT7R4'},
			//{title: 'Inducción UAysén', id: 'PKr5dMWS_lA'},
		],
		redes: Mock.redes
	}),
}
</script>